module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_1_5.2c262383.png";